import { FunctionComponent } from "react";
import classes from './index.module.css'

interface SmallFilterBoxProps {
    label: string
    value: string | number
    onclick?: () => void
}
 
const SmallFilterBox: FunctionComponent<SmallFilterBoxProps> = ({onclick, label, value}) => {
    return ( <div className={classes.container} onClick={onclick}>
        <span>{label}: </span>
        <span>{value}</span>
    </div> );
}
 
export default SmallFilterBox;